import React from "react";
import { Modal, ModalBody } from "reactstrap";
export default function ImageViewer({ isOpen, url, toggle }) {

  
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalBody className="text-center">
        <img src={url} alt="" style={{ maxWidth: "100%", maxHeight: "80vh", cursor:"zoom-out" }} onClick={toggle} />
      </ModalBody>
    </Modal>
  );
}
